import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  bar: {
    background: token.colorBgContainer,
    border: `1px solid ${token.colorBorderSecondary}`,
    borderRadius: token.borderRadiusLG,
    padding: `${token.paddingSM}px ${token.padding}px`,
    boxShadow: token.boxShadowTertiary
  },
  sticky: {
    position: 'sticky',
    bottom: token.paddingSM,
    zIndex: 2
  },
  start: {
    display: 'flex',
    alignItems: 'center',
    gap: token.marginSM,
    minWidth: 0,
    flex: 1
  }
}))
